import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaRegEye } from 'react-icons/fa6';
import { FaTimes } from 'react-icons/fa';
import classNames from 'classnames';
import secureLocalStorage from 'react-secure-storage';
import TimeAgo from '../helpers/TimeAgo';

const Notification = ({ setUnreadNoty }) => {
  const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));
  const userId = auth.id;
  const [activeTab, setActiveTab] = useState('unread');
  const [notifications, setNotifications] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState('desc'); // NEW: Sort order

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`https://buzzinguniverse.com/backend/api/get-notifications-request?user_id=${userId}`);
      setNotifications(res.data.data || []);
      console.log(res.data.data)
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleMarkAsRead = async (id) => {
    try {
      await axios.get(`https://buzzinguniverse.com/backend/api/mark-notification-read-request?notification_id=${id}`);
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
      fetchNotifications();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (ids) => {
    try {
      await axios.post('https://buzzinguniverse.com/backend/api/delete-notification-request', { notification_ids: ids });
      setNotifications(prev => prev.filter(n => !ids.includes(n.id)));
      setSelectedIds(prev => prev.filter(id => !ids.includes(id)));
      fetchNotifications();
    } catch (err) {
      console.error(err);
    }
  };

  const handleBulkAction = async (action) => {
    if (selectedIds.length === 0) return;
    if (action === 'read') {
      await axios.post('https://buzzinguniverse.com/backend/api/bulk-mark-notification-read-request', { notification_ids: selectedIds });
      setNotifications(prev =>
        prev.map(n => selectedIds.includes(n.id) ? { ...n, read: true } : n)
      );
    } else if (action === 'delete') {
      await handleDelete(selectedIds);
    }
    setSelectedIds([]);
    fetchNotifications();
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(_id => _id !== id) : [...prev, id]);
  };

  const toggleSortOrder = () => {
    setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
  };

  const filteredNotifications = [...notifications]
    .filter(n => activeTab === 'unread' ? !n.is_read : n.is_read)
    .sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });


  setUnreadNoty(filteredNotifications.length || 0);

  return (
    <div className="personal_right_box">
      <ul className="nav nav-pills mb-0" role="tablist">
        <li className="nav-item">
          <button
            className={classNames("nav-link", { active: activeTab === 'unread' })}
            onClick={() => setActiveTab('unread')}
          >
            UnRead
          </button>
        </li>
        <li className="nav-item">
          <button
            className={classNames("nav-link", { active: activeTab === 'read' })}
            onClick={() => setActiveTab('read')}
          >
            Read
          </button>
        </li>
      </ul>

      <div className="tab-content" id='pills-tabContent'>
        {loading ? (
          <div className="loader_post_wrap mt-5">
            <div className="loader_Post"></div>
          </div>
        ) : filteredNotifications.length === 0 ? (
          <div className="sorry-activity-found p-4" style={{ width: '75%' }}>
            <ul className='m-0'>
              <li><i className="fas fa-info" /></li>
              <li><p>No notifications found.</p></li>
            </ul>
          </div>
        ) : (
          <div className="notification-container">
            <table className="notification-table">
              <thead>
                <tr>
                  <th><input
                    type="checkbox"
                    checked={filteredNotifications.every(n => selectedIds.includes(n.id))}
                    onChange={(e) =>
                      setSelectedIds(e.target.checked ? filteredNotifications.map(n => n.id) : [])
                    }
                  /></th>
                  <th>Notification</th>
                  <th onClick={toggleSortOrder} style={{ cursor: 'pointer' }}>
                    Date Received <span className="sort-arrow">{sortOrder === 'asc' ? '▲' : '▼'}</span>
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredNotifications.map(notification => (
                  <tr key={notification.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(notification.id)}
                        onChange={() => handleCheckboxChange(notification.id)}
                      />
                    </td>
                    <td>
                      <a href={notification.notification_link || "#"}>{notification.notification_text}</a>
                    </td>
                    <td><TimeAgo date={notification.created_at} /></td>
                    <td>
                      {!notification.is_read && (
                        <span className="icon" title="Mark as Read" onClick={() => handleMarkAsRead(notification.id)}>
                          <FaRegEye />
                        </span>
                      )}
                      <span className="icon" title="Delete" onClick={() => handleDelete([notification.id])}>
                        <FaTimes />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="bulk-actions">
              <select onChange={(e) => handleBulkAction(e.target.value)} value="">
                <option value="">Bulk Actions</option>
                <option value="read">Mark as Read</option>
                <option value="delete">Delete</option>
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notification;
